/**
* Layered Images JS
* -----------------------------------------------------------------------------
*
* All the JS for the Layered Images component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';

( function( app ) {
  const COMPONENT = {

    className: 'layered-images',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( window.innerWidth > 1024 ) {
      // Select elements based on your actual structure
        const contentSections = gsap.utils.toArray( '.layered-images-section-content' );
        const images = gsap.utils.toArray( '.layered-image' );

        // Set initial state for all images
        gsap.set( images, {opacity: 0} );

        // Create animations for each section
        contentSections.forEach( ( section, index ) => {
          const image = images[index];

          ScrollTrigger.create( {
            trigger: section,
            start: 'top 20%', // Adjust these values as needed
            end: 'bottom 20%',
            refreshPriority: -1,
            // markers: true, // Keep markers on for debugging
            onEnter: () => gsap.to( image, {opacity: 1} ),
            onEnterBack: () => gsap.to( image, {opacity: 1} ),
            onLeaveBack: () => gsap.to( image, {opacity: 0} ),
          } );
        } );
      }

      setTimeout( ScrollTrigger.refresh(), 1000 );

      if ( $( '.layered-images__slider' ).length ) {
        $( '.layered-images__slider' ).each( function( index, element ) {
          const splide = new Splide( element, {
            type: 'loop',
            gap: '2rem',
            perPage: 1,
            perMove: 1,
            pagination: false,
            speed: 800,
            mediaQuery: 'min',
            breakpoints: {
              1024: {
                destroy: true,
              },
            },
          } ).mount( {} );

          splide.on( 'overflow', function( isOverflow ) {
            splide.options = {
              arrows: isOverflow,
              drag: isOverflow,
            };
          } );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'layered-images', COMPONENT );
} )( app );
